/**
 * Fonte única da data de revisão.
 *
 * LAST_REVIEWED afirma que uma pessoa revisou o conteúdo clínico. Por isso é
 * uma constante de bump manual, e não `new Date()`: um build não revisa nada,
 * e uma data que se atualiza sozinha alega uma revisão que não ocorreu — numa
 * página assinada com CRM isso é uma afirmação falsa, não um detalhe.
 *
 * Atualize esta linha quando o conteúdo for de fato revisado.
 *
 * A data de MODIFICAÇÃO (dateModified do JSON-LD, lastmod do sitemap) é outra
 * coisa: descreve quando os arquivos mudaram, é legitimamente automática e
 * vem do último commit, injetada por scripts/prerender.mjs.
 */
export const LAST_REVIEWED = '2026-08-15';

export const CRM = 'CRM/MG 105.721';

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

export function formatarData(iso, { maiusculas = false } = {}) {
  const [ano, mes, dia] = iso.split('-');
  const texto = `${dia} de ${MESES[Number(mes) - 1]} de ${ano}`;
  return maiusculas ? texto.toUpperCase() : texto;
}
